@if (initialized && dto) {
    @if (activeNavigationItems?.action == 'templateCalculationBase') {
        @if (widgetTemplateCalculationBase) {
            <mvs-widget
                    [widgetData]="widgetTemplateCalculationBase"
            ></mvs-widget>
        }
    }
    @if (activeNavigationItems?.action == 'templateCancellationBuffer') {
        @if (widgetTemplateCancellationBuffer) {
            <mvs-widget
                    [widgetData]="widgetTemplateCancellationBuffer"
            ></mvs-widget>
        }
    }
    @if (activeNavigationItems?.action == 'templateLiability') {
        @if (widgetTemplateLiability) {
            <mvs-widget
                    [widgetData]="widgetTemplateLiability"
            ></mvs-widget>
        }
    }
}
